import React, { useState } from "react";
import { Layout, Input, Button, Form, Row, Col, Breadcrumb, message, Typography, Alert } from "antd";
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { KeyOutlined, HomeOutlined, LockOutlined } from "@ant-design/icons";
import api from "../../services/axiosInstance";
import "../../styles/fluidDesign.css";
const { Content } = Layout;

const ChangeMyPassword = () => {
  const [loading, setLoading] = useState(false);
  const [addForm] = Form.useForm();

  const UPDATED_BY = localStorage.getItem("USERID");

  const handleAdd = async (values) => {
    
    if(values.txtoldpassword.trim() === "" || values.txtoldpassword.trim() === null)
    {
        message.error("please enter your current password.");
        return;
    }

    if(values.txtnewpassword.trim() === "" || values.txtnewpassword.trim() === null)
    {
        message.error("please enter your new password.");
        return;
    }

    if(values.txtrenewpassword.trim() === "" || values.txtrenewpassword.trim() === null)
    {
        message.error("please Re-enter your new password.");
        return;
    }

    if(values.txtnewpassword.trim().length < 6)
    {
        message.error("At least 6 characters needed for your new password");
        return;
    }

    var regularExpression = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,15}$/;

    if(!regularExpression.test(values.txtnewpassword.trim()))
    {
        message.error("Password should contain at least one number and one alphabet letter, only numbers and alphabet letters are allowed");
        return;
    }

    if(values.txtnewpassword.trim() !== values.txtrenewpassword.trim())
    {
        message.error("Your re-entered password did not match with new password");
        return;
    }

    const payload = {
      currentpw: values.txtoldpassword,
      newpw: values.txtnewpassword,
      updatedby: UPDATED_BY,
    };

    try {
      setLoading(true);
      const response = await api.post("/settings/user/changepassword.php", payload);

      // eslint-disable-next-line eqeqeq
      if (response.data.status == "success") {
        message.success(response.data.message || "Password Changed successfully.");
        addForm.resetFields();
      } else {
        throw new Error(response.data.message || "Failed to change");
      }
    } catch (error) {
      message.error(error.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="fluid-page">
      <Headerdiv />
      
      {/* Fluid Page Header */}
      <div className="fluid-page-header">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <Row align="bottom" justify="space-between">
            <Col>
                                    <Breadcrumb
                        className="fluid-breadcrumb"
                        items={[
                            { href: '/dash', title: <HomeOutlined /> },
                            { title: 'Profile' },
                            { title: 'Change Password' },
                        ]}
                    />
                <h1 className="fluid-page-title">
                    <LockOutlined /> Change Password
                </h1>
            </Col>
            <Col xs={0} md={12} style={{ textAlign: 'right' }}>
                <p className="fluid-page-subtitle">Update your account security credentials</p>
            </Col>
        </Row>
      </div>

      <Content className="fluid-content">
        {/* Password Change Card */}
        <Row justify="center">
          <Col xs={24} md={16} lg={12}>
            <div className="fluid-card">
              <div className="fluid-card-header">
                <h3 className="fluid-card-title">Update Password</h3>
              </div>

              <Alert
                message="Password Requirements"
                description={
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    <li>Minimum 6 characters, maximum 15 characters</li>
                    <li>Only numbers and alphabet letters are allowed</li>
                    <li>Must contain at least one number and one alphabet letter</li>
                  </ul>
                }
                type="info"
                showIcon
                style={{ marginBottom: 24 }}
              />

              <Form
                form={addForm}
                layout="vertical"
                onFinish={handleAdd}
              >
                <Form.Item
                  label="Current Password"
                  name="txtoldpassword"
                  rules={[{ required: true, message: "Please enter your current password" }]}
                >
                  <Input.Password
                    maxLength={15}
                    placeholder="Enter your current password"
                    className="fluid-input"
                  />
                </Form.Item>

                <Form.Item
                  label="New Password"
                  name="txtnewpassword"
                  rules={[{ required: true, message: "Please enter your new password" }]}
                >
                  <Input.Password
                    maxLength={15}
                    placeholder="Enter your new password"
                    className="fluid-input"
                  />
                </Form.Item>

                <Form.Item
                  label="Confirm New Password"
                  name="txtrenewpassword"
                  rules={[{ required: true, message: "Please re-enter your new password" }]}
                >
                  <Input.Password
                    maxLength={15}
                    placeholder="Re-enter your new password"
                    className="fluid-input"
                  />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<KeyOutlined />}
                    loading={loading}
                    size="large"
                    block
                  >
                    Update Password
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Content>
      <Footerdiv />
    </Layout>
  );
};

export default ChangeMyPassword;